module.exports = {"TXTWCL_Browse_tournaments":{"id":"TXTWCL_Browse_tournaments","defaultMessage":"Versenyek böngészése","track":"Browse tournaments"}}